/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface OnboardingStepResponse {
  message: string;
  current_step: number;
  workos_org_id?: string | null;
}
